import { z } from "zod";

import { insuranceSchema } from "./schemas";

export const INSURANCE_ELIGIBILITY = {
  IN_NETWORK: "in_network",
  NOT_IN_NETWORK: "not_in_network",
  NOT_IN_NETWORK_SPECIAL: "not_in_network_special",
} as const;

export type Insurance = z.infer<typeof insuranceSchema>;

export type InsuranceEligibility =
  (typeof INSURANCE_ELIGIBILITY)[keyof typeof INSURANCE_ELIGIBILITY];
